import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import { Container } from "../styles/container";
import CustomButton from "../components/CustomButton";
const Section = styled.section`
  background: rgb(132, 50, 11);
  background: linear-gradient(
    90deg,
    rgba(132, 50, 11, 1) 0%,
    rgba(203, 134, 11, 1) 80%
  );
  // padding: 20px 0px;
`;

const Content = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 40px;
  }
`;

const Left = styled.div`
  padding: 30px 0px;
  @media (max-width: 767px) {
    order: 1;
  }
  > h1 {
    font-family: var(--casanova);
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0.2rem;
    line-height: 1.4;
    margin-bottom: 15px;
    text-transform: uppercase;
    text-align: left;

    @media (max-width: 1399px) {
      font-size: 40px;
    }
    @media (max-width: 1199px) {
      font-size: 32px;
    }
    @media (max-width: 991px) {
      font-size: 26px;
    }
    @media (max-width: 767px) {
      text-align: left;
    }
    @media (max-width: 400px) {
      font-size: 20px;
    }
  }
  > p {
    font-size: 16px;
    font-family: var(--montserrat);
    line-height: 1.5;
    margin-bottom: 5px;
    text-align: left;

    @media (max-width: 567px) {
      font-size: 12px;
    }
  }
`;

const Right = styled.div`
  height: 100%;
  position: relative;
  img {
    width: 100%;
    // height: 100%;
    // object-fit: cover;
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    @media (max-width: 767px) {
      position: unset;
    }
  }
  @media (max-width: 767px) {
    order: 2;
  }
`;

const TextContent = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;

const SimulationPage = () => {
  const handleNavigate = () => {
    window.open("https://experimentadda.in/", "_blank");
  };
  return (
    <>
      <CustomHelmet
        title="Learn Faster with Interactive Simulations | Arcaptor"
        description="Experience hands-on learning like never before with Experiment Adda! Accelerate your understanding through engaging, interactive simulations."
      />
      <MainLayout>
        <Section>
          <Container>
            <Content>
              <Left>
                <h1>
                  Learn faster through interactive simulations—experience
                  hands-on learning like never before with Experiment Adda!
                </h1>
                <p>#ExperimentAdda</p>
              </Left>
              <Right>
                <img src="./images/simulationHero.png" alt="simulationHero" />
              </Right>
            </Content>
          </Container>
        </Section>
        <Container>
          <TextContent>
            <h2 className="main_heading">
              Discover Experiment Adda: Redefining Hands-On Learning in Science
              and Math
            </h2>
            <p>
              Experiment Adda is revolutionizing the way students experience
              education by offering interactive, immersive, and engaging
              simulations that bring science and mathematics to life. With a
              mission to make learning more accessible, practical, and exciting,
              Experiment Adda bridges the gap between theoretical concepts and
              real-world applications, fostering curiosity and deeper
              understanding among learners.
            </p>
            <br />
            <h4>Explore Our State-of-the-Art Virtual Labs</h4>
            <br />
            <p>
              Experiment Adda offers five specialized labs designed to ignite
              interest and enhance learning:
            </p>
            <br />
            <ul>
              <li>
                <strong>1. Physics Lab:</strong> Uncover the wonders of motion,
                electricity, thermodynamics, and more through engaging
                experiments.
              </li>
              <li>
                <strong>2. Chemistry Lab:</strong>
                Safely explore chemical reactions, molecular structures, and
                bonding with realistic simulations.
              </li>
              <li>
                <strong>3. Biology Lab:</strong>
                Dive into cell biology, genetics, human anatomy, and ecosystems
                to unravel the mysteries of life.
              </li>
              <li>
                <strong>4. Mathematics Lab:</strong>
                Visualize complex concepts like algebra, geometry, and calculus
                with interactive tools.
              </li>
              <li>
                <strong>5. Earth Science Lab:</strong>
                Investigate weather patterns, geological processes, and
                environmental studies in a virtual setting.
              </li>
            </ul>
            <br />
            <h4>Why Experiment Adda Stands Out</h4>

            <br />
            <ul>
              <li>
                <strong>1. Interactive and Realistic:</strong>
                Experience hands-on experiments in a virtual space that feels
                tangible and intuitive.
              </li>
              <li>
                <strong>2. Curriculum-Aligned:</strong>
                Tailored for Classes 10, 11, and 12, aligning with Indian
                education standards.
              </li>
              <li>
                <strong>3. Multilingual Access:</strong>
                Learn in your preferred language with content available in
                multiple Indian languages.
              </li>
              <li>
                <strong>4. Safe and Convenient:</strong> Conduct experiments
                anywhere, anytime, without the need for a physical lab.
              </li>
            </ul>
            <br />
            <h4>Our Vision and Mission</h4>
            <br />
            <ul>
              <li>
                <strong> Vision:</strong> To make quality education accessible
                to all through innovative technology and pedagogy.
              </li>
              <li>
                <strong> Mission:</strong> Empower students to explore,
                experiment, and learn actively, inspiring lifelong curiosity and
                growth.
              </li>
            </ul>
            <br />
            <h4>Join the Learning Revolution</h4>
            <br />

            <p>
              Experiment Adda is more than just a learning platform—it's a
              gateway to an exciting, hands-on educational adventure. Whether
              you’re a student aiming to excel in exams, a teacher enriching
              lessons, or a lifelong learner, Experiment Adda is your partner in
              turning education into an unforgettable journey.
            </p>
            <br />
            <p>
              Make learning interactive, engaging, and impactful with Experiment
              Adda!
            </p>

            <CustomButton
              title="Visit Experiment Adda"
              width="180px"
              onClick={handleNavigate}
              className="campus"
            />
          </TextContent>
        </Container>
      </MainLayout>
    </>
  );
};

export default SimulationPage;
